// Stan listy dokumentów Subiekta musi przeżyć przemontowanie widoku.
//
// <router-view> w Dashboard.vue ma :key="route.fullPath", więc wejście w ?id= i powrót
// montują widok listy od nowa. Bez tego modułu wybrany dzień wracałby za każdym razem
// na dzisiejszy, a dokumenty leciałyby z sieci od zera — przy kilkunastu trasach
// dziennie to zauważalne czekanie przy każdym powrocie.
//
// Moduł jest wykonywany raz na cały czas życia aplikacji, więc to, co tu trzymamy,
// jest niezależne od cyklu życia komponentów.

const cache = new Map();
let lastDate = null;
let lastTab = null;

export function getLastDate() {
    return lastDate;
}

export function setLastDate(date) {
    lastDate = date;
}

export function getLastTab() {
    return lastTab;
}

export function setLastTab(tab) {
    lastTab = tab;
}

export function getCachedDocuments(date) {
    return cache.get(date) || null;
}

export function setCachedDocuments(date, payload) {
    cache.set(date, payload);
}

// Po wysłaniu dokumentu dane w pamięci są nieaktualne — kasujemy wpis, żeby powrót
// na listę nie pokazał starego statusu.
export function invalidateDocuments(date) {
    if(date == null) {
        cache.clear();
        return;
    }
    cache.delete(date);
}
